import { render, staticRenderFns } from "./buyBack.vue?vue&type=template&id=20780bc8&"
import script from "./buyBack.vue?vue&type=script&lang=js&"
export * from "./buyBack.vue?vue&type=script&lang=js&"
import style0 from "./buyBack.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports